import CaptainActionApprovalsAPI from 'dashboard/api/captain/actionApprovals';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

// Deciding does not touch `records`: every caller lists `status: pending`, so removing the row
// here would drop it out of the list - and unmount the card mid-click - before the component that
// dispatched has run its own success handling. The refetch that follows the decision owns the list.
export default createStore({
  name: 'CaptainActionApproval',
  API: CaptainActionApprovalsAPI,
  actions: mutations => ({
    approve: async ({ commit }, id) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainActionApprovalsAPI.approve(id);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
    reject: async ({ commit }, id) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainActionApprovalsAPI.reject(id);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
  }),
});
